import { render } from "./ApiSettings.vue?vue&type=template&id=5c680eb0&scoped=true"
import script from "./ApiSettings.vue?vue&type=script&lang=js"
export * from "./ApiSettings.vue?vue&type=script&lang=js"

import "./ApiSettings.vue?vue&type=style&index=0&id=5c680eb0&scoped=true&lang=scss"

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c680eb0"]])

export default __exports__